import React, {useState} from "react";
import {Advert} from "../types/Advert";
import {formatCurrency, formatNumber} from "../utils/numberFormat";

type AdvertCardProps = {
    advert: Advert;
}

function dateDiffInDays(a: Date, b: Date) {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

function calcAdvertAge(d: string) {
    if (!d) return "";

    const days = dateDiffInDays(new Date(d), new Date());

    if (days <= 5) {
        return "New Listing";
    }
    return "";
}

const AdvertCard: React.FC<AdvertCardProps> = ({advert}) => {
    const distance = advert._geoDistance ? Math.round(advert._geoDistance / 1609.34 * 10) / 10 : 0;
    const [loggedIn, setLoggedIn] = useState((window as any).loggedIn);
    const advertAge = calcAdvertAge(advert.firstSeenDate);

    return (
        <a href={`https://choosemycar.com/vehicle/${advert.id}`} className="vehicle-card mx-n2 mx-md-0">
            {advertAge && <div className="advert-date">{advertAge}</div>}
            <div className="vehicle-card-img">
                <img src={advert.image.smallMedium} alt="" loading="lazy"
                     onError={function ({currentTarget}) {
                         currentTarget.onerror = null;
                         currentTarget.src = "https://assets.choosemycar.com/coming-soon.png";
                     }}/>
            </div>
            <div className="vehicle-info">
                <h4 className="vehicle-name mb-0">{advert.make.name + " " + advert.model.name} <br/>
                    <span>{advert.variant.name}</span></h4>
                <p className="vehicle-specs mb-0">{advert.year} | {advert.slugs.transmission} | {formatNumber(advert.mileage)} miles
                    | {advert.fuelType.name} </p>
                {advert._geoDistance &&
                    <p className="vehicle-distance mb-0"><small>{distance} mile{distance > 1 && "s"} away</small></p>}
                {loggedIn &&
                advert.dealer.isApproved ? <div className="approved-dealer">Approved dealer</div> : ""
                }
            </div>
            <div className="prices">
                <dl className="finance-price">
                    <dt>Finance From</dt>
                    <dd className="price text-primary lh-1">{formatCurrency(Math.round(advert.lowestMonthlyFinanceFrom.pence / 100))}<span>/month</span>
                    </dd>
                </dl>
                <dl className="cash-price">
                    <dt>Cash Price</dt>
                    <dd className="price lh-1">{formatCurrency(advert.price)}</dd>
                </dl>
            </div>
        </a>
    )
}

export default AdvertCard;